
var ProductBundle = function(product, productChilds, previewCoordinates, bundleConfig, targetPreview, targetChilds, targetSelectedItems){
  	this.items = [];
  	this.selectedItems = [];
  	this.product = product;
  	this.thumbSize = 'small';
  	this.mainImageSize = 'medium';
  	this.targetPreview = targetPreview;
  	this.targetChilds = targetChilds;
  	this.targetSelectedItems = targetSelectedItems;
  
  	this.setSelectedItem = function(variant){
    	// add the item to the 
      	var json = {};
      	json.id = variant.id;
      	json.qty = variant.qty;
      	json.productId = variant.productId;
      	this.selectedItems.push(json);
    }
    
    this.deleteSelectedItem = function(/*variantId,*/ index){
    	// delete the item from selected items
      	/*for(selectedItemKey in this.selectedItems){
          if(this.selectedItems[selectedItemKey].id == variantId){
              var idx = this.selectedItems.indexOf(this.selectedItems[selectedItemKey]);
              if (idx != -1) {
                  this.selectedItems.splice(idx, 1); // The second parameter is the number of elements to remove.
                  this.refreshPreview();
                  return true;
              }
              return false;

          }
      	}*/
      
      var idx = this.selectedItems.indexOf(this.selectedItems[index]);
      if (idx != -1) {
        this.selectedItems.splice(idx, 1); // The second parameter is the number of elements to remove.
        this.refreshPreview();
        return true;
      }
      return false;
    }
    
    this.setItems = function(){
      	var childs = JSON.parse(productChilds);
      	
      	var i = 1;
      	for(key in childs) {
            var item = this.getProduct(childs[key].handle);
          	item.header = childs[key].header;
            item.product_limit = childs[key].product_limit;
            item.variant_limit = childs[key].variant_limit;
          	item.priority = i;
            
            this.items.push(item);
          	i++;
        }
    }
    
    this.getSelectedItems = function(){
    	return this.selectedItems;
    }
    
    this.getSelectedItem = function(variantId){
      for(selectedItemKey in this.selectedItems){
        if(this.selectedItems[selectedItemKey].id == variantId){
        	return this.selectedItems[selectedItemKey]
        }
      }
      return false;
    }
    
    this.getItems = function(){
      	return this.items;
    }
    
    this.getItemVariant = function(productId, variantId){
      	for(itemKey in this.items){
          if(this.items[itemKey].id == productId){
            for(variantKey in this.items[itemKey].variants){
              if(this.items[itemKey].variants[variantKey].id == variantId){
                this.items[itemKey].variants[variantKey].product_limit = this.items[itemKey].product_limit;
                this.items[itemKey].variants[variantKey].variant_limit = this.items[itemKey].variant_limit;
                this.items[itemKey].variants[variantKey].priority = this.items[itemKey].priority;
              	return this.items[itemKey].variants[variantKey];
              }
            }
          }
          
        }
      	return false;
    }
    
    this.getProduct = function(handle){
      response = {};
      $.ajax({
        type: "GET",
        url: '/products/'+handle+'.js',
        async: false,
        dataType: 'JSON',
        success: function(data){
          if(data.available){
          	response = data;
          }
        }
      });
      
      return response;
    }

    this.buildItemHtml = function(item){
      html = '<div id="'+ item.handle +'-wrapper" class="clearfix">';
      html += '<div class="title clearfix"><span class="step">Step '+ item.priority + "</span> - " + item.header +'<span class="open-close">-</span></div>';
      html += '<div class="content clearfix">';
     
      if(item.variants && item.variants.length > 0){
        for(variantKey in item.variants){
          if(item.variants[variantKey].available && item.variants[variantKey].featured_image){
            imgSrc = item.variants[variantKey].featured_image.src.split('?')[0];
            html += '<a href="#" class="bundleVariant" data-product="'+item.id+'" data-variant="'+item.variants[variantKey].id+'">';
            html += '<div class="item">';
            html += '<img src="'+ imgSrc.slice(0, -4) +'_'+this.thumbSize+'.png" />';
            html += '<br/><div class="info"><span class="title">'+ item.variants[variantKey].title +'</span><br/>'+ Shopify.formatMoney(item.variants[variantKey].price, formatMoney) +'</div>';
            html += '</div>';
            html += '</a>';
          }
        }      	
      }
      html += '</div></div>';
      return html;
    }
    
    this.buildSelectedItemsHtml = function(){
    	html = '';
      	
      	if(this.selectedItems.length > 0){
          for(selectedItemKey in this.selectedItems){
            var itemData = this.getItemVariant(this.selectedItems[selectedItemKey].productId, this.selectedItems[selectedItemKey].id);
            imgSrc = itemData.featured_image.src.split('?')[0];
            html += '<div class="bundleVariantSelected" data-variant="'+selectedItemKey+'">';
            html += '<img src="'+ imgSrc.slice(0, -4) +'_'+this.thumbSize+'.png" />';
            html += '<div class="info">';
            html += '<span class="price">'+Shopify.formatMoney(itemData.price, "")+'</span>';
			html += '<span class="quantity">x'+this.selectedItems[selectedItemKey].qty+'</span>';
			html += '<a href="#" data-variant="'+this.selectedItems[selectedItemKey].id+'" data-product="'+this.selectedItems[selectedItemKey].productId+'" data-index="'+selectedItemKey+'" class="deleteSelected"><i class="fa fa-trash-o"></i></a>';
            html += '</div>';
            html += '</div>';                                                       
			
          }
        }
      
      	return html;
    }
    
    this.init = function(){
      	productBundle = this;
    	productBundle.setItems();
      	items = productBundle.getItems();

        for(key in items){
			productBundle.targetChilds.append(productBundle.buildItemHtml(items[key]));
        }      
        
      	productBundle.bindEvents();
              
        productBundle.refreshPreview();
    }
    
    this.submitProducts = function(){
      	var scope = this;
      	bundleCode = randomstring(5);
      
        if(scope.selectedItems.length == 0){
          alert('You must select at least one item.');
          return false;
        }    
        $('#add-cart-overlay').fadeIn();
      
		var itemsToAdd = [];

		itemsToAdd.push({
			'id': $('#product-id').val(),
			'properties': { 
				"bundle code": bundleCode,
				"bundlePreview": {
					"backgroundImage": $("#bundle-preview").css('background-image'),
					"backgroundSize": $("#bundle-preview").get(0).style.backgroundSize,
                    "backgroundPosition": $("#bundle-preview").get(0).style.backgroundPosition,
				}
			},
			'quantity': $('#quantity').val()
		});

		var i = 1;
		for(selectedItemsKey in scope.selectedItems){
			var itemProperties = { 
				'bundle code': bundleCode,
				'qty': scope.selectedItems[selectedItemsKey].qty
			};
			if(bundleConfig.arrange_order) { 
				itemProperties.item_order = i;
			}
			itemsToAdd.push({
				'id': scope.selectedItems[selectedItemsKey].id,
				'quantity': $('#quantity').val()*scope.selectedItems[selectedItemsKey].qty,
				'properties': itemProperties
			});
			
			i++;
		}
		
		scope.addItemsToTheCart(itemsToAdd);
    }
	
	this.addItemsToTheCart = function(itemsToAdd) {
		var scope = this;
		if (itemsToAdd.length) {
			var item = itemsToAdd.pop();
			$.ajax({
				url: '/cart/add.js',
				type: 'POST',
				data: item,
				success: function(){scope.addItemsToTheCart(itemsToAdd)},
				error: function(){scope.addItemsToTheCart(itemsToAdd)}
			});
		} else {
			window.location.href = '/cart';
		}
	}

    this.getProductSelectedCount = function(productId){
      count = 0;
      for(itemKey in this.selectedItems){
        if(this.selectedItems[itemKey].productId == productId){
        	count += this.selectedItems[itemKey].qty;
        }
      }
      
      return count;
    }
    
    this.setSelectedItemQty = function(variantId, qty){
    	for(itemKey in this.selectedItems){
          if(this.selectedItems[itemKey].id == variantId){
              this.selectedItems[itemKey].qty = qty;
          }
        }
    }
    
    this.saveBundle = function(productId, variantId){
      variant = this.getItemVariant(productId, variantId);

      variant.productId = productId;
      selectedVariant = this.getSelectedItem(variantId);
      
      if(this.getProductSelectedCount(productId) < variant.product_limit || variant.product_limit == 0){
        if(selectedVariant){

          if(selectedVariant.qty < variant.variant_limit || variant.variant_limit == 0){
            
            if(bundleConfig.arrange_order === 1){
          		variant.qty = 1;
          		this.setSelectedItem(variant);  	
            }else{
            	qty = selectedVariant.qty+1;
                this.setSelectedItemQty(selectedVariant.id, qty);
            }
          }	
        }else{
          variant.qty = 1;
          this.setSelectedItem(variant);
        }
      }

      this.refreshSelectedBundle();
      this.refreshPreview();
          
    }
    
    this.saveBundleOrder = function(productId, variantId){
      variant = this.getItemVariant(productId, variantId);

      variant.productId = productId;
      selectedVariant = this.getSelectedItem(variantId);
      
      if(this.getProductSelectedCount(productId) < variant.product_limit || variant.product_limit == 0){
        if(selectedVariant){

          if(selectedVariant.qty < variant.variant_limit || variant.variant_limit == 0){
            
            if(bundleConfig.arrange_order === 1){
          		variant.qty = 1;
          		this.setSelectedItem(variant);  	
            }else{
            	qty = selectedVariant.qty+1;
                this.setSelectedItemQty(selectedVariant.id, qty);
            }
          }	
        }else{
          variant.qty = 1;
          this.setSelectedItem(variant);
        }
      }
          
    }
    
    this.saveByOrder = function(){
      var scope = this;
      scope.selectedItems = [];
      targetSelectedItems.find('.bundleVariantSelected').each(function(){
      	var variantId = $(this).find('a').data('variant');
        var productId = $(this).find('a').data('product');
        
        scope.saveBundleOrder(productId, variantId);
        
      });
      scope.refreshSelectedBundle();
      scope.refreshPreview();
    }
    
    this.updateProductPrice = function(){
      price = product.price;
      for( selectedItemsKey in this.selectedItems){
        var itemData =  this.getItemVariant(this.selectedItems[selectedItemsKey].productId, this.selectedItems[selectedItemsKey].id);
      	price += itemData.price*this.selectedItems[selectedItemsKey].qty;
      }
      //$('#bundle-selected-items .totals .total span').html(Shopify.formatMoney(price, formatMoney));
      $('#product-wrap.bundle .header .total span').html(Shopify.formatMoney(price, formatMoney));
      
      if(this.selectedItems.length > 0){
      		$('#product-wrap.bundle .header .total, #product-wrap.bundle .header .addToCart').addClass('show');
      }else{
        	$('#product-wrap.bundle .header .total, #product-wrap.bundle .header .addToCart').removeClass('show');
      }
    }
    
    this.refreshSelectedBundle = function(){
      	productBundle = this;
      	selectedItemsContainer = targetSelectedItems.parent();
      	if(productBundle.selectedItems.length > 0){
        	selectedItemsContainer.slideDown();
        }else{
        	selectedItemsContainer.slideUp();
        }
    	targetSelectedItems.html(productBundle.buildSelectedItemsHtml());
      	productBundle.updateProductPrice();
      	
      	productBundle.loadSelectedBundleCarousel();
      	
      	$('.deleteSelected').click(function(){
          productBundle.deleteSelectedItem($(this).data('index'));
          productBundle.refreshSelectedBundle();
          return false;
        });
      
        if(bundleConfig.arrange_order === 1){
          targetSelectedItems.find('.owl-wrapper').sortable({
            beforeStop: function(event, ui){
        		productBundle.saveByOrder();
            }
          });
        }
      
    }
    
    this.loadSelectedBundleCarousel = function(){
      
      var owl = targetSelectedItems.data('owlCarousel');
      var owlOptions = {items : 4, //10 items above 1000px browser width
        itemsDesktop : [1000,4], //5 items between 1000px and 901px
        itemsDesktopSmall : [900,4], // betweem 900px and 601px
        itemsTablet: [600,2], //2 items between 600 and 0
        itemsMobile : false, // itemsMobile disabled - inherit from itemsTablet option
		mouseDrag: false,
        touchDrag:false
      }
      
      if(owl){
        owl.reinit(owlOptions);
        return false;
      }
      owl = targetSelectedItems.owlCarousel(owlOptions);

      // Custom Navigation Events
      targetSelectedItems.parent().find('.next').click(function(){
        owl.trigger('owl.next');
      });
      targetSelectedItems.parent().find('.prev').click(function(){
        owl.trigger('owl.prev');
      });
    }
    
    this.refreshPreview = function(){
      	var productBundle = this;
      	var bundlePreview = this.targetPreview;

      	var bgPreview = [];
		var imagesCount = 0;
        for(selectedItemKey in this.selectedItems){
          	var itemData = this.getItemVariant(this.selectedItems[selectedItemKey].productId, this.selectedItems[selectedItemKey].id);
          	var imgSrc = itemData.featured_image.src;

          	for(var i=0; i<this.selectedItems[selectedItemKey].qty; i++) {
              if(!bgPreview[itemData.priority]) {
                bgPreview[itemData.priority] = [];
              }
              bgPreview[itemData.priority].push(
              	{
                    img: 'url('+imgSrc.slice(0, -4) +'.png)', 
                    //size: (itemData.priority==1 ? '335px' : '185px'), 
                  	size: (itemData.priority==1 ? '100%' : '50%'), 
                    position: productBundle.getBackgroundPosition(itemData, bgPreview[itemData.priority].length)
                }
              );
          	}
        }
		bgPreview = bgPreview.reverse();
      
      	var backgroundImage = '';
      	var backgroundSize = '';
      	var backgroundPosition = '';
      
      	for(priority in bgPreview) {
      		var items = bgPreview[priority];
          	$.each(items, function(key, item){
          		backgroundImage += item.img + ',';
                backgroundSize += item.size + ',';
                backgroundPosition += item.position + ',';
          	});
      	}
      	backgroundImage = backgroundImage.substring(0, (backgroundImage.length-1));
      	backgroundSize = backgroundSize.substring(0, (backgroundSize.length-1));
      	backgroundPosition = backgroundPosition.substring(0, (backgroundPosition.length-1));
      
        if(backgroundImage=="") {
          	backgroundImage = 'url('+productBundle.product.featured_image.slice(0, -4) +'.png)';
          	backgroundSize = '100%';
        }

      	bundlePreview.css({
          	//width: '440px',
          	//height: '500px',
          	width: '100%',
          	height: '100%',
          	backgroundImage: backgroundImage,
          	backgroundRepeat: 'no-repeat',
          	backgroundSize: backgroundSize,
          	backgroundPosition: backgroundPosition,
        });
      
      	//Fix refresh background-image IE
      	var wrapper = $('#'+bundlePreview.attr('id')).parent();
      	var clone = bundlePreview.clone();
      	wrapper.html('');
      	clone.appendTo(wrapper);
    }
    
    this.getBackgroundPosition = function(item, index) {
      	
      var positions = (previewCoordinates == null) ? ["53% 80%", "65% 78%", "41% 78%", "25% 70%", "77% 70%", "19% 60%", "85% 60%", "10% 50%", "93% 50%"] : JSON.parse(previewCoordinates);

      	//return (item.priority==1 ? '30px 0px' : (positions[index] ? positions[index] : positions[0]));
      return (item.priority==1 ? '0px 0px' : (positions[index] ? positions[index] : positions[0]));
    }
    
    this.bindEvents = function(){
      var scope = this;
      $('.bundleVariant').click(function(){
      	scope.saveBundle($(this).data('product'), $(this).data('variant'));
        return false;
      });
      
      $('#bundle-childs-wrapper .title').click(function(){
      	var content = $(this).parent().find('.content');
        if(content.is(':visible')) {
        	$(this).find('span.open-close').html('+');
        } else {
        	$(this).find('span.open-close').html('-');
        }
        content.slideToggle();
      });
      
      $('#product-actions').submit(function(){
        debugger;
      	scope.submitProducts();
        
        return false;
      });
    }
    
}

var BundleCart = function(){
    this.cart = {},
    this.setCart = function(){
      bundleCart = this;
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        async: false,
        dataType: 'json',
        success: function(response){
        	bundleCart.cart = response;
        }
      });
    }
    
    this.init = function(){
    	this.setCart();
    }

    this.removeItemBundle = function(bundleCode){
      bundleCart = this;
      quantity = [];
      
      for(itemKey in bundleCart.cart.items){
        
        if(bundleCart.cart.items[itemKey].properties != null && bundleCart.cart.items[itemKey].properties['bundle code'] == bundleCode){
        	bundleCart.cart.items[itemKey].quantity = 0;
        }
        quantity.push(bundleCart.cart.items[itemKey].quantity);
      
      }
      
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {"updates": quantity},
        async: false,
        success: function(data){
			//location.reload();
        }
      });
    }
  }

function randomstring(L){
    var s= '';
    var randomchar=function(){
    	var n= Math.floor(Math.random()*62);
    	if(n<10) return n; //1-10
    	if(n<36) return String.fromCharCode(n+55); //A-Z
    	return String.fromCharCode(n+61); //a-z
    }
    while(s.length< L) s+= randomchar();
    return s;
}